import React, { useState } from "react";
import {
  IconAttachment,
  IconCode,
  IconGoToTab,
  IconQr,
} from "../../../../../utils/icons";
import { EmbedCodePanel } from "./EmbedCodePanel";
import { PreviewUrlPanel } from "./PreviewUrlPanel";
import { IEmbed } from "../../embedsV2/interface";
import { Projects } from "./storyFormCotainer/Projects";
import { TabHeader, TabPanel } from "../../../../../components/Tabs";
import { QrCodePanel } from "./QrCodePanel";

interface Props {
  embed: IEmbed;
  openSettings: () => void;
  panelHeight: number;
}

export function ShareEmbedModal({ panelHeight, ...props }: Props) {
  const [selectedTab, setSelectedTab] = useState(0);

  const tabHeader = [
    {
      value: 0,
      text: "Embed Code",
      Icon: IconCode,
    },
    {
      value: 1,
      text: "Video URL",
      Icon: IconAttachment,
    },
    {
      value: 2,
      text: "QR Code",
      Icon: IconQr,
    },
  ];

  return (
    <>
      <TabHeader
        containerClassName="p-6"
        tabs={tabHeader}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />

      <TabPanel value={selectedTab} index={0} height={panelHeight - 260}>
        <EmbedCodePanel {...props} />
      </TabPanel>
      <TabPanel value={selectedTab} index={1} height={panelHeight - 260}>
        <PreviewUrlPanel {...props} />
      </TabPanel>
      <TabPanel value={selectedTab} index={2} height={panelHeight - 260}>
        <QrCodePanel {...props} />
      </TabPanel>
    </>
  );
}
